/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import FaqsMainContainer from './faqs-main/container/FaqsMainContainer';
import FaqSubContainer from './faqs-sub/container/FaqSubContainer';

function FaqsContainer({ match, pathName }) {
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/general-settings/faqs/main"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('general-settings/faqs/main') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Frequently Asked Questions Menu
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/general-settings/faqs/sub"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('general-settings/faqs/sub') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Frequently Asked Questions Sub
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/main`} />}
          />
          <Route
            path={`${match.path}/main`}
            component={FaqsMainContainer}
          />
          <Route
            path={`${match.path}/sub`}
            component={FaqSubContainer}
          />
        </Switch>
      </div>
    </React.Fragment>
  );
}

FaqsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(FaqsContainer);
